import React, { useEffect, useState } from "react";
import { logoImg1 } from "@/assets/headimage";
import MyUser from "@/components/business/User";
import Notice from "@/components/business/Notice";
import { useNavigate } from "react-router-dom";
import User from "@/stores/userStore";
import { observer } from "mobx-react";
import { Popover } from "@arco-design/web-react";
import dayjs from "dayjs";
import "./index.less";
import { getUserPermissions } from "@/components/business/RolePermission";
import appStore from "@/stores/appStore";
import { aidConfig } from "@/platformConfig";

const Header: React.FC = (props) => {
  const navigate = useNavigate();
  function formatDurationDetailed(seconds) {
    if (seconds <= 0) return "0秒";

    const units = [
      { name: "年", seconds: 365 * 24 * 3600 },
      { name: "月", seconds: 30 * 24 * 3600 },
      { name: "天", seconds: 24 * 3600 },
      { name: "小时", seconds: 3600 },
      { name: "分钟", seconds: 60 },
      { name: "秒", seconds: 1 },
    ];

    let remaining = seconds;
    const parts = [];

    for (const unit of units) {
      const value = Math.floor(remaining / unit.seconds);
      if (value > 0) {
        parts.push(`${value}${unit.name}`);
        remaining -= value * unit.seconds;
      }
    }

    return parts.join("");
  }

  const [overHeight, setOverHeight] = useState<boolean>(false);
  useEffect(() => {
    const image = new Image();
    image.src = aidConfig.loginIcon;
    image.onload = function () {
      setOverHeight(image.height >= image.width);
    };
  }, []);
  return (
    <div className="header_root">
      <div
        className="logo-box"
        onClick={() => {
          navigate("/account-management");
        }}
      >
        <div style={{ width: User.logoWidth, textAlign: "center" }}>
          <img
            src={aidConfig.logo}
            style={{ marginTop: 2, width: overHeight ? "auto" : "90%", height: overHeight ? "60px" : "auto" }}
          />
        </div>
      </div>
      {getUserPermissions("6") ? (
        <div className="head-user-money">
          <span>云币：{User.userInfo.balance ? User.userInfo.balance / 100 : "-"}</span>
          <Popover
            content={User.userInfo.banlance?.map((v, i) => (
              <div key={i} style={{ padding: 10 }}>
                <p>
                  活动币: {v.balance ? v.balance / 100 : 0}, {dayjs.unix(v.expired_at).format("YYYY-MM-DD HH:mm:ss")}
                  到期
                </p>
              </div>
            ))}
          >
            <span>
              活动币：
              {User.userInfo.banlance?.length
                ? User.userInfo.banlance.reduce((pre, cur) => {
                    if (cur.expired_at < new Date().getTime() / 1000) {
                      return pre;
                    }
                    return pre + (cur.balance ? cur.balance / 100 : 0);
                  }, 0)
                : "-"}
            </span>
          </Popover>
          <span>数字人时长：{User.userInfo.digital_time ? `${User.userInfo.digital_time}s` : "-"}</span>
        </div>
      ) : (
        <></>
      )}
      <div className="tool-box">
        <Notice />
        <div>
          <MyUser />
        </div>
      </div>
    </div>
  );
};

export default observer(Header);
